// extracted by mini-css-extract-plugin
export default {"modalImage":"CheatSheets_modalImage__JHQm7","div":"CheatSheets_div__K54Kd","image":"CheatSheets_image__ZCyI8","header":"CheatSheets_header__Ocjc1"};